import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Isvg from 'react-inlinesvg';

import { getBlogPosts } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';
import { logout } from '../../actions/user';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import BlogCard from '../../components/BlogCard';
import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

import ContentContainer from '../../components/ContentContainer';

class Blog extends Component {
  constructor(props) {
    super(props);
    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);

    this.state = {
      posts: [],
      loaded: false,
    };
  }

  componentWillMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      this.setState({ loaded: true, posts: [] });
      return;
    }

    this.fetchBlogPosts();
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(
      updateAppState({
        login_modal_open: true,
      }),
    );
  }

  fetchBlogPosts() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(getBlogPosts()).then(
          response => {
            this.setState({
              posts: response.posts,
              loaded: true,
            });

            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.props.history.push('/404');
          },
        );
      });
  }

  render() {
    return (
      <Body hasFooter>
        <SEO
          title="Dog Care Blog - Tips, Stories & Advice"
          description={
            'Read the latest articles about dog care, training tips, and heartwarming ' +
            'stories from The Dog Share Collective community.'
          }
          keywords="dog blog, dog care tips, dog training, dog stories, pet care advice"
          url="https://www.thedogsharecollective.com/blog"
        />
        {this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props}
          />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        )}
        <div className={css(styles.heading_section)}>
          <ContentContainer styles={styles.body_container}>
            <h1 className={css(styles.heading)}>Dog e-Blog</h1>
          </ContentContainer>
        </div>

        <ContentContainer styles={styles.container}>
          <div className={css(styles.cards)}>
            {this.state.posts && this.state.posts.length
              ? this.state.posts.map(post => (
                  <BlogCard
                    slug={post.slug}
                    image={post.thumbnail_url}
                    title={post.title}
                    date={post.date}
                    summary={post.summary}
                  />
                ))
              : false}
            {this.state.loaded && this.state.posts && this.state.posts.length === 0 ? (
              <h3>Our blog is empty at the moment.</h3>
            ) : (
              false
            )}
          </div>
        </ContentContainer>
        <Footer user={this.props.user} />
      </Body>
    );
  }
}

Blog.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  more: {
    position: 'relative',
    height: 120,
    marginTop: 50,
  },
  cards: {
    // display: 'grid',
    // gridTemplateColumns: 'repeat(4, 262px)',
    // gridGap: 30,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  body_container: {
    padding: '50px 0',
  },
  main: {
    paddingLeft: 43,
  },
  container: {
    padding: '60px 0 0',
  },
  heading_section: {
    paddingTop: 80,
    backgroundColor: '#f9f9f9',
  },
  heading: {
    marginBottom: 0,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Blog);



// WEBPACK FOOTER //
// ./src/views/Blog/index.js